import { updateListing } from '../../../app-main/actions/listing';
import { toggleBanner } from '../../../app-main/actions/banner';
import { get, assign } from 'lodash';

const onSubmitCleaningFeeForm = (values, dispatch, props) => {
  const accessToken = get(props, 'accessToken', '');
  const listingId = get(props, 'listing._id', '');
  const cleaningFee = get(values, 'cleaning_fee', {});
  const value = 'DEACTIVATED' === cleaningFee.obj_state ? 0 : parseInt(cleaningFee.value, 10);
  const payload = { cleaning_fee: assign({}, cleaningFee, { value }, { apply_as: 'FLAT_RATE' }) };

  dispatch(updateListing(listingId, accessToken, payload))
    .then(() => dispatch(toggleBanner('save')))
    .catch(() => dispatch(toggleBanner('error')));
};

export default onSubmitCleaningFeeForm;
